// import 'antd/dist/antd.css';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    Row,
    Col,
    Card,
    Avatar,
    Button,
    Divider,
    Pagination,
    Alert,
    Modal,
} from 'antd';
import PropTypes from 'prop-types';
// import { createSelector } from 'reselect';
import moment from 'moment';
import '../../css/ant-design-style.css';
import image2 from '../../Images/noProfile.png';
import ResponsiveHeader from './ResponsiveHeader';
import { CalendarOutlined } from '@ant-design/icons';
import whatsapp from '../../Images/whatsapp.png';
import { Content } from 'antd/es/layout/layout';
import { pastAppointmentsRequest, todayAppointmentsRequest, upComingAppointmentsRequest } from './Actions';
import { selectLoading, selectPastAppointmentsList, selectTodayAppointmentsList, selectUpComingAppointmentsList } from './Selectors';
import { useNavigate } from 'react-router-dom';
import CustomSpin from '../CommonSpin';
import { BodyTextGrey, BodyTextHeadingAppointment, BodyTextValue, TittleHeader } from '../CommonText';
// import { selectTodayAppointmentsList } from './Selectors';
import english from '../../Translations/English.json';
import hindi from '../../Translations/Hindi.json';
import malayalam from '../../Translations/Malayalam.json';

const Appointment = () => {
    const dispatch = useDispatch();

    const [selected, setSelected] = useState('1');
    // const [currentPage, setCurrentPage] = useState(1);
    const [visiblePayment, setVisiblePayment] = useState(false);
    const [gatewayUrl, setGatewayUrl] = useState(null);
    const [current, setCurrent] = useState(1);

    const navigate = useNavigate();

    const langid = localStorage.getItem('INTL') ? (localStorage.getItem('INTL')) : 'en';
    const langdata = langid && langid == 'en' ? english : langid == 'ma' ? malayalam : langid == 'hin' ? hindi : english;

    let temp = 0;
    useEffect(() => {
        if(temp == 0) {
            dispatch(todayAppointmentsRequest(1));
        }
        temp +=1;
        // dispatch({ type: 'CHECK_PATIENT_PROFILE_EXIST' });
        // localStorage.setItem('PATHCLICKED', '/appointment');
        // dispatch({ type: APPOINTMENT_REQUEST_TODAY, payload: '1' });
        // dispatch({ type: GET_DEPARTMENT });
    }, []);

    const today = useSelector(selectTodayAppointmentsList);
    const upcoming = useSelector(selectUpComingAppointmentsList);
    const past = useSelector(selectPastAppointmentsList);
    const requesting = useSelector(selectLoading);
    // const department = useSelector(makeSelectDepartment());
    let total = 0;

    if (selected === '1') {
        total = today && today.total ? today.total : 0;
    }
    else if (selected === '2') {
        total = upcoming && upcoming.total ? upcoming.total : 0;
    }
    else if (selected === '3') {
        total = past && past.total ? past.total : 0;
    }

    const totalPage = (total / 4) * 10;

    const handlePage = (page) => {
        setCurrent(page);

        if (selected === '1') {
            dispatch(todayAppointmentsRequest(page));
        }
        else if (selected === '2') {
            dispatch(upComingAppointmentsRequest(page));
        } else if (selected === '3') {
            dispatch(pastAppointmentsRequest(page));
        }
    };

    // const info = () => {
    //     Modal.info({
    //         title: 'Room will be available only before 10 minutes',
    //         onOk() { },
    //     });
    // };

    const urlExpiryCheck = (value) => {
        // Navigate to the waiting room
        navigate(('/waitingroom'),{state : {data : value }});

    };

    const paymentTrigger = (value) => {
        setGatewayUrl(value.gatewayUrl);
        setVisiblePayment(true);
    };

    const handleCancelPayment = () => {
        setVisiblePayment(false);
    };

    const handleOkPayment = () => {
        // dispatch({ type: PAYMENT_INITIATED });
        window.open(gatewayUrl);
        setVisiblePayment(false);
    };

    const appointmentBody = () => {
        let appointments = [];
        if (selected === '1') {
            appointments = today && today.data;
            total = today && today.total;
        }
        else if (selected === '2') {
            appointments = upcoming && upcoming.data;
            total = today && today.total;
        }
        else if (selected === '3') {
            appointments = past && past.data;
            total = today && today.total;
        }

        return appointments?.map((item) => {
            // if (item.createdByOrgId === 1 || item.createdByOrgId === 140) {
            const supportNumber = item.supportNumber;
            const datee = moment().format('HH:mm:ss');
            const temptime = `${item.date},${item.time} GMT+0530 (India Standard Time)`;
            const istTime = new Date(temptime);
            const utcDate = new Date(istTime).toISOString();
            // const localDate = new Date(utcDate);
            // const timeDisplay = moment(localDate).format('hh:mm A');
            // const timeDate = moment(localDate).format('YYYY-MM-DD');
            const utcMoment = moment.utc(utcDate);        
            const istMoment = moment(utcMoment).add(5, 'hours').add(30, 'minutes');
            const timeDisplay = istMoment.format('hh:mm A');
            const timeDate = istMoment.format('YYYY-MM-DD');
            const dt = moment(moment(item.time, 'HH:mm:ss')).format('HH:mm:ss');
            const start = moment.utc(datee, 'HH:mm');
            const end = moment.utc(dt, 'HH:mm');
            const d = moment.duration(end.diff(start));
            const d1 = moment.utc(+d).format('H:mm');
            let flag;

            if (d1 >= '0:05') {
                    flag = true; // eslint-disable-line
            } else {
                    flag = false; // eslint-disable-line
            }

            return (
                <Col
                    key={item.id}
                    xs={{ span: 24, offset: 0 }}
                    sm={{ span: 24, offset: 0 }}
                    md={{ span: 12, offset: 0 }}
                    lg={{ span: 12, offset: 0 }}
                    xl={{ span: 8, offset: 0 }}
                    xxl={{ span: 6, offset: 0 }}
                    style={{display:'flex', justifyContent:'center'}}


                >
                    <div
                        key={item.id}
                        style={{
                            float: 'left',
                            paddingBottom: '1%',
                            paddingLeft: '15px',
                        }}
                    >
                        <Card
                            key={item.id}
                            style={{
                                boxShadow: '0px 15px 20px rgba(0, 0, 0, 0.15)',
                                borderRadius: '8px',
                                width: '320px',
                                height: '490px',
                                marginBottom: '10px'
                            }}
                        >
                            <Row>
                                <Col xs={{ span: 24 }} lg={{ span: 24 }} style={{}}>
                                    <div style={{ paddingBottom: '12px', textAlign: 'center' }}>
                                        <Avatar
                                            style={{
                                                borderWidth: 2,
                                                borderColor: '#CACACA',
                                                borderStyle: 'double',
                                            }}
                                            size={100}
                                            src={item.docprofilephotourl === null ? image2 : item.docprofilephotourl}
                                        />
                                    </div>
                                    <div
                                        style={{
                                            textAlign: 'center',
                                            fontFamily: 'Roboto',
                                            color: '#4F4F4F',
                                            fontSize: '16px',
                                            letterSpacing: '-0.0024em',
                                            fontStyle: 'normal',
                                            lineHeight: 'normal',
                                            fontWeight: '600',
                                        }}
                                    >
                                        <BodyTextHeadingAppointment text={`${item.docinitials} ${item.docfirstName} ${item.doclastName}`} />
                                    </div>
                                    <div
                                        style={{
                                            paddingTop: '10px',
                                            textAlign: 'center',
                                            fontFamily: 'Roboto',
                                            color: '#828282',
                                            fontSize: '14px',
                                            letterSpacing: '-0.0016em',
                                            fontStyle: 'normal',
                                            lineHeight: 'normal',
                                        }}
                                    >
                                        <BodyTextGrey text={item.docdescriptions} />
                                    </div>
                                    <div
                                        style={{
                                            textAlign: 'center',
                                            fontFamily: 'Roboto',
                                            color: '#828282',
                                            fontSize: '14px',
                                            letterSpacing: '-0.0016em',
                                            fontStyle: 'normal',
                                            lineHeight: 'normal',
                                            wordWrap: 'break-word',
                                        }}
                                    >
                                        <BodyTextGrey text={item.docspecialization} />
                                    </div>
                                </Col>
                            </Row>
                            <Divider style={{ marginBottom: '16px', marginTop: '16px' }} />
                            <Row>
                                <Col span={24} style={{ paddingBottom: '8px' }}>
                                    <div
                                        style={{
                                            fontFamily: 'Roboto',
                                            color: '#828282',
                                            fontSize: '14px',
                                            letterSpacing: '-0.0016em',
                                            fontStyle: 'normal',
                                            lineHeight: 'normal',
                                        }}
                                    >
                                        <BodyTextGrey text={`${langdata.AppointmentID ? langdata.AppointmentID : 'Appointment ID' }`} /> : <BodyTextGrey text={item.id} /> <br />
                                        <BodyTextGrey text={`${langdata.AppointmentType ? langdata.AppointmentType : 'Appointment Type'}`} /> :{' '}
                                        {item.consultationtypeId === 1 || item.consultationtypeId === 2 || item.consultationtypeId === 10
                                            ? <BodyTextGrey text={`${langdata.HospitalVisit ? langdata.HospitalVisit : 'Hospital Visit' }`} />
                                            : <BodyTextGrey text={`${langdata.VideoConsultation ? langdata.VideoConsultation : 'Video Consultation' }`}/>}{' '}
                                        <br />
                                        <BodyTextGrey text={`${langdata.OrganisationName ? langdata.OrganisationName : 'Organisation Name'}`} /> : <BodyTextGrey text={item.consultingOrgName} />
                                        <br />
                                        {item.consultationtypeId === 1 || item.consultationtypeId === 2 || item.consultationtypeId === 10 ? null :
                                            <span>
                                                <BodyTextGrey text={`${langdata.MeetingID ? langdata.MeetingID : 'Meeting ID' }`} /> :{' '}
                                                <span style={{ color: 'red' }}>
                                                    <BodyTextGrey text={item.meetingid} color='red' />
                                                </span>
                                            </span>}
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24} style={{ paddingTop: '10px'}}>
                                    <div
                                        style={{
                                            // fontFamily: 'Roboto',
                                            color: '#4F4F4F',
                                            fontSize: '14px',
                                            letterSpacing: '-0.0016em',
                                            fontStyle: 'normal',
                                            lineHeight: 'normal',
                                            fontWeight: '550',
                                            // display: 'flex',
                                            // justifyContent: 'center'
                                        }}
                                    >
                                        {moment(timeDate).format('dddd Do')}, {moment(timeDate).format('MMM ')} at{' '}
                                        {`${timeDisplay}`}  {'(IST)'}
                                    </div>
                                </Col>
                            </Row>
                            {/* BUTTON */}
                            {/* (Add your button handling here) */}
                            {(item.status === 'Confirmed' && item.consultationtypeId !== 1) ||
                                    ((item.status === 'inProgress' || item.status === 'Confirmed') &&
                                        item.consultationtypeId !== 1 &&
                                        item.consultationtypeId !== 10 &&
                                        item.consultationtypeId !== 12 &&
                                        item.consultationtypeId !== 2) ? (
                                    <Row span={24} style={{justifyContent:'center', display:'flex'}}>
                                        <Col span={24} style={{ marginTop: '35px', justifyContent:'center', display:'flex' }}>
                                            {item.consultationtypeId === 1 || item.consultationtypeId === 2 || item.consultationtypeId === 1 ? null : <Button
                                                className="ant-buttonJoin"
                                                style={{
                                                    height: '38px',
                                                    width: '184px',
                                                    // fontFamily: 'Roboto',
                                                    // left: '10%',
                                                    // left: '8.15%',
                                                    // right: '15.15%',
                                                    borderRadius: '4px',
                                                    boxShadow: '0px 8px 10px rgba(0, 0, 0, 0.15)',
                                                }}
                                                onClickCapture={() => {
                                                    localStorage.setItem('APPOINTMENT_ID', item.id);
                                                }}
                                                onClick={() => {urlExpiryCheck(item);}}
                                            >
                                                {langdata.JoinConsultingRoom ? langdata.JoinConsultingRoom : 'Join Consulting Room'}
                                            </Button>}
                                        </Col>
                                    </Row>
                                ) 
                                : null
                            }
                            {item.status === 'created' ? (
                                <Row span={24} style={{justifyContent:'center', display:'flex'}}>
                                    <Col span={24} style={{marginTop:'35px',justifyContent:'center', display:'flex' }}>
                                        <Button
                                            className="ant-buttonJoin"
                                            style={{
                                                height: '38px',
                                                width: '184px',
                                                // fontFamily: 'Roboto',
                                                // left: '10%',
                                                // right: '15.15%',
                                                borderRadius: '4px',
                                                boxShadow: '0px 8px 10px rgba(0, 0, 0, 0.15)',
                                                // marginTop: '-10px',
                                                // display: 'flex',
                                                // justifyContent: 'center'
                                            }}
                                            // onClickCapture={() => {
                                            //     localStorage.setItem('APPOINTMENT_ID', item.id);
                                            // }}
                                            onClick={() => { paymentTrigger(item); }}                                        
                                        >
                                            {langdata.ConfirmBooking ? langdata.ConfirmBooking : 'Confirm Booking'}
                                        </Button>
                                    </Col>
                                </Row>
                            ) : null}
                            {item.status === 'Finished' ? (
                                <Row span={24} style={{justifyContent:'center', display:'flex'}}>
                                    <Col span={24} style={{marginTop:'35px',justifyContent:'center', display:'flex' }}>
                                        <Button
                                            disabled
                                            // className="ant-buttonJoin"
                                            style={{
                                                height: '38px',
                                                width: '184px',
                                                // fontFamily: 'Roboto',
                                                // left: '10%',
                                                // right: '15.15%',
                                                borderRadius: '4px',
                                                boxShadow: '0px 8px 10px rgba(0, 0, 0, 0.15)',
                                                // marginTop: '-10px',
                                                // display: 'flex',
                                                // justifyContent: 'center'
                                            }}
                                            // onClickCapture={() => {
                                            //     localStorage.setItem('APPOINTMENT_ID', item.id);
                                            // }}
                                        >
                                            {langdata.Finished ? langdata.Finished : 'Finished'}
                                        </Button>
                                    </Col>
                                </Row>
                            ) : null}
                            {supportNumber != null ? (
                                <Row style={{ marginTop: '40px'}}>
                                    <Col span={6} style={{display:'flex', justifyContent:'right' }}>
                                        <img style={{ height: '30px'}} src={whatsapp} />
                                    </Col>
                                    <Col span={1}>&nbsp;</Col>
                                    <Col span={17} style={{ marginTop: '3px', display:'flex', justifyContent:'left' }}>
                                        <BodyTextValue text= {`${langdata.Support ? langdata.Support : 'Support' }`} />&nbsp;-&nbsp;<a href={`https://wa.me/91${supportNumber}`} target="_blank" rel="noreferrer">{supportNumber}</a>
                                    </Col>
                                </Row>
                            // <div style={{ marginTop: '20px', marginLeft: '8.15%', marginRight: '15.15%'}}>
                            //     <img style={{ height: '30px' }} src={whatsapp} />
                            // </div>
                            ) : null}
                        </Card>
                    </div>
                </Col>
            );
            // }
        });
    };

    return (
        <Content>
            <div style={{ marginTop: '8px' }}>
                <Row type="flex" justify="center">
                    <Col xs={{ span: 0 }} md={{ span: 24, offset: 0 }}>
                        <Col
                            xs={{ span: 0 }}
                            md={{ span: 24 }}
                            style={{
                                marginBottom: '15px',
                            }}
                        >
                            <Col
                                xs={{ span: 0 }}
                                md={{ span: 23 }}
                                lg={{ span: 23 }}
                                xl={{ span: 23 }}
                                xxl={{ span: 23 }}
                                style={{
                                    marginLeft: '2%',
                                    background: '#fff',
                                    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.04)',
                                    borderRadius: '4px',
                                }}
                            >
                                <div
                                    style={{
                                        marginLeft: '1%',
                                        textAlign: 'left',
                                        // fontFamily: 'Roboto',
                                        fontSize: '27px',
                                        color: '#1164A6',
                                        padding: '8px',
                                        display: 'flex'
                                    }}
                                >
                                    {/* <Icon type="calendar" style={{ fontSize: '30px' }} />{' '} */}
                                    {/* <FormattedMessage {...messages.myAppointment} /> */}
                                    <CalendarOutlined />
                                    <TittleHeader text={`${langdata.MyAppointments ? langdata.MyAppointments : 'My Appointment' }`} color='#1164A6' />
                                </div>
                            </Col>
                        </Col>
                    </Col>
                </Row>
                <Row>
                    <Col xs={{ span: 24 }}>
                        <Col xs={{ span: 24 }} style={{ marginBottom: '20px', marginLeft: '1%' }}>
                            <ResponsiveHeader selected={selected} setSelected={setSelected} setCurrent = {setCurrent}/>
                        </Col>
                        <Col xs={{ span: 24 }} lg={{ span: 24 }} style={{ marginLeft: '2%' }}>
                            <Col xs={{ span: 23 }} style={{ minHeight: '400px' }}>
                                {requesting === true ? (
                                    <div style={{ textAlign: 'center', marginTop: '120px' }}>
                                        <CustomSpin spinning={requesting} />
                                    </div>
                                ) : (
                                    <div>
                                        {appointmentBody() && appointmentBody().length > 0 ?
                                            <Row>
                                                {appointmentBody()}
                                            </Row>

                                            : (
                                                <div style={{ textAlign: 'center' }}>
                                                    <h1>
                                                        <Alert
                                                            message={`${langdata.NoAppointments ? langdata.NoAppointments : 'No Appointments'}`}
                                                            description={`${langdata.Youhavenoappointments ? langdata.Youhavenoappointments : 'You have no appointments!' }`}
                                                            type="info"
                                                        />
                                                    </h1>
                                                </div>
                                            )}
                                    </div>
                                )}
                            </Col>
                            <Col
                                xs={{ span: 24 }}
                                style={{ textAlign: 'center', marginTop: '20px', marginBottom: '10px', display: 'flex', justifyContent: 'center' }}
                            >
                                <Pagination
                                    xs={{ span: 24 }}
                                    lg={{ span: 24 }}
                                    defaultCurrent={1}
                                    hideOnSinglePage
                                    current={current}
                                    onChange={handlePage}
                                    total={parseInt(totalPage)}
                                    showSizeChanger={false}
                                />
                                {/* <Pagination 
                                    current={current} 
                                    onChange={handlePage} 
                                    total={parseInt(totalPage)} 
                                /> */}
                            </Col>
                        </Col>
                    </Col>
                </Row>
                <Modal
                    open={visiblePayment}
                    onCancel={handleCancelPayment}
                    footer={[
                        <Button key="back" onClick={handleCancelPayment}>
                            No
                        </Button>,
                        <Button key="submit" type="primary" onClick={handleOkPayment}>
                            Pay
                        </Button>,
                    ]}
                >
                    <h3>To confirm this booking please proceed to payment</h3>
                </Modal>
            </div>
        </Content>
    );
};

Appointment.propTypes = {
    dispatch: PropTypes.func,
    today: PropTypes.object,
    requesting: PropTypes.object,
    upcoming: PropTypes.object,
    past: PropTypes.object,
    selected: PropTypes.object,
    department: PropTypes.object,
};

export default Appointment;
